// Claude: New page — "update [USER_MANUAL.md], and make it accessible on the site." Renders the
// Claude: same USER_MANUAL*.md files the repo already maintains (imported directly, same pattern
// Claude: About.js already uses for about*.txt) rather than duplicating their content as JSX, so
// Claude: the two can never drift out of sync with each other.
import React, { useState, useEffect, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import manual_en from "../USER_MANUAL.md";
import manual_af from "../USER_MANUAL_af.md";
import manual_fr from "../USER_MANUAL_fr.md";
import manual_pt from "../USER_MANUAL_pt.md";
import { pickContentLanguage } from "../contentLanguage";
import SharedStateContext from "../context/sharedstate";
import Navbar from "../navbar";
import Navbaranonuser from "../navbaranonuser";
import { useTranslation } from "react-i18next";
import "../i18n";
import { AuthContext } from "../context/AuthContext";
import Logo from "../logo512.png";

// Claude: which raw-imported file to fetch per translated content language — see
// Claude: contentLanguage.js for which languages have a real translation.
const MANUAL_SOURCES = { en: manual_en, af: manual_af, fr: manual_fr, pt: manual_pt };

function UserManual() {
  const { auth } = useContext(AuthContext);
  const { interfaceLanguage } = useContext(SharedStateContext);
  const [manualText, setManualText] = useState("");
  const navigate = useNavigate();
  const { t } = useTranslation();

  const contentLanguage = pickContentLanguage(interfaceLanguage);

  useEffect(() => {
    fetch(MANUAL_SOURCES[contentLanguage])
      .then((response) => response.text())
      .then((text) => setManualText(text));
  }, [contentLanguage]);

  return (
    <div className="min-h-screen bg-gray-100">
      {localStorage.setItem("bladsy", "UserManual")}
      {auth.userName === null && <Navbaranonuser />}
      {auth.userName != null && <Navbar />}
      <div className="prose prose-lg p-4 max-w-4xl mx-auto">
        <button
          onClick={() => navigate(-1)}
          className="ml-0 bg-gray-500 text-white py-2 mt-4 mb-0 px-4 rounded-lg hover:bg-gray-600"
        >
          {t("back")}
        </button>
        <ReactMarkdown remarkPlugins={[remarkGfm]}>{manualText}</ReactMarkdown>
      </div>
      <div className="flex flex-col justify-center items-center p-4">
        <Link to={"/"}>
          <img src={Logo} alt="Logo" width="100" height="100" />
        </Link>
      </div>
    </div>
  );
}

export default UserManual;
